import {
    GoogleAuthProvider,
    FacebookAuthProvider,
    signInWithPopup,
} from "firebase/auth";
import { auth } from "./config";
import { loginWithSocial } from "../redux/zservices/BasicAPIFunctions";

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

/**
 * GOOGLE LOGIN
 */
export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const credential = GoogleAuthProvider.credentialFromResult(result);

        const data = {
            social_from: 2,
            social_token: credential?.idToken,
        };

        const userdetailsforsignup = {
            first_name: result.user.displayName?.split(" ")[0] || "",
            last_name: result.user.displayName?.split(" ")[1] || "",
            email_id: result.user.email,
            image: result.user.photoURL,
        };

        const loginRes = await loginWithSocial(data);
        return {
            loginRes,
            userdetailsforsignup,
        };
    } catch (error) {
        console.error("Google Login Error:", error);
        throw error;
    }
};


/**
 * FACEBOOK LOGIN
 */
export const signInWithFacebook = async () => {
    try {
        console.log('signInWithFacebook');

        const result = await signInWithPopup(auth, facebookProvider);

        const user = result.user;
        console.log(result, 'resultresultresultresultresultresultresult');

        const credential = FacebookAuthProvider.credentialFromResult(result);

        const data = {
            social_from: 3, // 3 = Facebook
            social_id: user.uid,
            social_token: credential?.accessToken,
        };
        console.log(data, 'datadatadatadata');

        // return await loginWithSocial(data);
    } catch (error) {
        console.error("Facebook Login Error:", error);
        throw error;
    }
};
